module.exports = __webpack_public_path__ + "img/main_visual_animal03.d5b86aba.png";